import { InputNumerico } from "app/components/inputs/InputNumerico";
import { DetalhesComissoes, ProgramaDeRelacionamento } from "app/types/comissoes/Indicadores";
import { ParametroPorItem } from "app/types/Parametro";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";

const estiloDetalhesComissao = require("./detalhes-comissao.module.scss").default;
const estiloFormulario = require("./../../../../estilos/formulario.module.scss").default;

export type DetalhesComissaoProps = {
  processando: boolean
  comissao: DetalhesComissoes;
  parametrosPorFilial?: ParametroPorItem[]; // 469844
  programasDeRelacionamento: ProgramaDeRelacionamento[];
  parametroObrigatorioInformarIndicadorNaVenda: boolean // 443809
  onAplicarComissao: (comissao: DetalhesComissoes) => void;
  onPercentualComissaoDiferenciada: (valor: number) => void;
  exibirCampoProgramaDeRelacionamento: boolean;
  exibirCampoPercentualComissaoDiferenciada: boolean;
  somenteLeitura: boolean;
  ocorreuDesvio?: number;
};

export const DetalhesComissao = (props: DetalhesComissaoProps) => {
  const [enderecoFaturamento, setEnderecoFaturamento] = useState(props.comissao.EnderecoFaturamentoIndicador);
  const [liberarPagamentoComissao, setLiberarPagamentoComissao] = useState(props.comissao.LiberarPagamentoComissaoCaixa);
  const [bloquearGeracaoContaAPagarIndicador, setBloquearGeracaoContaAPagarIndicador] = useState(props.comissao.BloquearGeracaoContaAPagarIndicador) // 443809
  const [programaDeRelacionamento, setProgramaDeRelacionamento] = useState(props.comissao.ProgramaDeRelacionamento);

  const valorParametroPorFilial = (nome: string) => props.parametrosPorFilial .find((p) => p.Nome == nome)?.Valor

  const botaoAplicarComissao = <>
    {!props.somenteLeitura &&
      <button
        type="button"
        id="DetalhesComissao_botaoAplicarComissao"
        className={clsx('no-global-button', estiloDetalhesComissao.botao)}
        disabled={props.processando}
        onClick={() => {
            props.onAplicarComissao({
              ...props.comissao,
              LiberarPagamentoComissaoCaixa: liberarPagamentoComissao,
              BloquearGeracaoContaAPagarIndicador: bloquearGeracaoContaAPagarIndicador, // 443809
              EnderecoFaturamentoIndicador: enderecoFaturamento,
              ProgramaDeRelacionamento: programaDeRelacionamento,
            })
          }
        }
      >
        Aplicar
      </button>
    }
  </>

  const campoNomeIndicador = <>
    <label>Nome</label>
    <div style={{ fontWeight: 700, backgroundColor: "var(--mu-superficie, #FFFFFF)" }}
      id="DetalhesComissao_nomeIndicador"
      title="Veja parâmetros: &#013;-Obrigatório Informar o Indicador na Venda&#013;-Bloquear campos valor mercadoria, valor comissão, end. faturamento e liberar comissão de pagamento&#013;&#013;Veja Segurança: &#013;-Indicadores&#013;&nbsp;&nbsp;-Campo Programa de Relacionamento na Tela de Indicadores&#013;&nbsp;&nbsp;-Campo Percentual de Comissão Diferenciada na Tela de Indicadores"
    >
      {props.comissao.Nome.toUpperCase()}
    </div>
  </>

  const campoBaseCalculoComissaoIndicador = valorParametroPorFilial("BLOQUEAR_APRESENTACAO_CAMPOS_DO_TRATAMENTO_DE_COMISSAO_POR_INDICACAO") != "S" && // 469844
  <>
    <label
      id="DetalhesComissao_labelBaseCalculoComissaoIndicador"
    >Base de Cálculo</label>
    <div
      id="DetalhesComissao_baseCalculoComissaoIndicador"
    >
      {globalMU.formatarValorNumerico(props.comissao.BaseCalculoComissao, 2, true)}
    </div>
  </>

  const campoComissaoIndicador = valorParametroPorFilial("BLOQUEAR_APRESENTACAO_CAMPOS_DO_TRATAMENTO_DE_COMISSAO_POR_INDICACAO") != "S" &&  // 469844
  <>
    <label
      id="DetalhesComissao_labelComissaoIndicador"
    >Comissão</label>
    <div
      id="DetalhesComissao_comissaoIndicador"
    >
      {globalMU.formatarValorNumerico(props.comissao.ValorComissao, 2, true)}
    </div>
  </>

  const campoPercentualComissaoDiferenciada = <>
  <label
    id="DetalhesComissao_labelPercentualComissaoDiferenciada"
  >% de Comissão Diferenciada</label>
  <div>
    <InputNumerico
        valor={props.comissao.PercentualComissao}
        id="DetalhesComissao_percentualComissaoDiferenciada"
        onValorModificado={props.onPercentualComissaoDiferenciada}
        disabled={props.somenteLeitura || props.processando}
        selecionaValorOnFocus={true}
        style={{ maxWidth: '70px', minWidth: '50px'}}
        ocorreuDesvio={props.ocorreuDesvio}
    /> %
  </div>
  </>

  const checkboxEnderecoFaturamentoIndicador = valorParametroPorFilial("BLOQUEAR_APRESENTACAO_CAMPOS_DO_TRATAMENTO_DE_COMISSAO_POR_INDICACAO") != "S" &&  // 469844
  <>
    <label className={props.somenteLeitura ? "_cursor-not-allowed _text-gray-400" :"_cursor-pointer"}
      id="detalheComissao-LabelEnderecoFaturamentoIndicador"
      htmlFor="detalheComissao-EnderecoFaturamentoIndicado">
      Endereço de Faturamento do Indicador</label>
    <div><input
      className={estiloDetalhesComissao.checkbox}
      type="checkbox"
      id="detalheComissao-EnderecoFaturamentoIndicado"
      checked={enderecoFaturamento ?? false}
      onChange={() => setEnderecoFaturamento(!enderecoFaturamento)}
      disabled={props.somenteLeitura || props.processando}
    /></div>
  </>

  const checkboxLiberarPagamentoDiretamenteCaixa = valorParametroPorFilial("BLOQUEAR_APRESENTACAO_CAMPOS_DO_TRATAMENTO_DE_COMISSAO_POR_INDICACAO") != "S" &&  // 469844
  <>
    <label className={props.somenteLeitura ? "_cursor-not-allowed _text-gray-400" :"_cursor-pointer"}
      title="Veja parâmetro: Bloquear campos valor mercadoria, valor comissão, end. faturamento e liberar comissão de pagamento"
      id="detalheComissao-LabelLiberarPagamentoDiretamenteCaixa"
      htmlFor="detalheComissao-liberarPagamentoDiretamenteCaixa">
      Liberar Pagamento de Comissão Diretamente no Caixa</label>
    <div><input
      className={estiloDetalhesComissao.checkbox}
      id="detalheComissao-liberarPagamentoDiretamenteCaixa"
      type="checkbox"
      checked={liberarPagamentoComissao ?? false}
      onChange={() =>setLiberarPagamentoComissao(!liberarPagamentoComissao)}
      disabled={props.somenteLeitura || props.processando}
    /></div>
  </>

const checkboxBloquearGeracaoContaAPagarIndicador = valorParametroPorFilial("BLOQUEAR_APRESENTACAO_CAMPOS_DO_TRATAMENTO_DE_COMISSAO_POR_INDICACAO") != "S" &&  // 469844
<>
  <label className={props.somenteLeitura || !props.parametroObrigatorioInformarIndicadorNaVenda ? "_cursor-not-allowed _text-gray-400" : "_cursor-pointer"} 
    htmlFor="detalheComissao-checkboxBloquearGeracaoContaAPagarIndicador"
    id="detalheComissao-LabelDoCheckboxBloquearGeracaoContaAPagarIndicador"
    title="Veja parâmetro: Obrigatório Informar o Indicador na Venda" //443809
  >Não Gerar Comissão</label>
  <div>
  <input
    className={estiloDetalhesComissao.checkbox}
    id="detalheComissao-checkboxBloquearGeracaoContaAPagarIndicador"
    type="checkbox"
    checked={bloquearGeracaoContaAPagarIndicador ?? false}
    onChange={(e) => setBloquearGeracaoContaAPagarIndicador(!bloquearGeracaoContaAPagarIndicador)}
    disabled={props.somenteLeitura || props.processando || !props.parametroObrigatorioInformarIndicadorNaVenda}
  />
  </div>
</>

const campoProgramaDeRelacionamento = <>
  <label className={props.somenteLeitura ? "_cursor-not-allowed _text-gray-400" :"_cursor-pointer"}
    id="detalheComissao-LabelProgramaDeRelacionamento"
    htmlFor="detalheComissao-programaDeRelacionamento"
  >Programa de Relacionamento</label>
  <div>
    <select 
        id="detalheComissao-programaDeRelacionamento"
        style={{'height': '32px', 'width': '300px'}}
        onChange={(e) => { setProgramaDeRelacionamento(e.target.value) }}
        value={(programaDeRelacionamento) ?? ""}
        disabled={props.somenteLeitura || props.processando}
    >
      <option value={"0"}>Selecione</option>
      {props.programasDeRelacionamento?.map(programa => (
        <option key={programa.Codigo} value={programa.Codigo}>
          {programa.Nome}
        </option>
      ))}
    </select>
  </div>
</>
  return (
    <>
      <div className={estiloFormulario.gridDuasColunas}>
        {campoNomeIndicador}
        {campoBaseCalculoComissaoIndicador}
        {campoComissaoIndicador}
        {(props.exibirCampoPercentualComissaoDiferenciada) && campoPercentualComissaoDiferenciada}
        {checkboxEnderecoFaturamentoIndicador}
        {checkboxLiberarPagamentoDiretamenteCaixa}
        {(props.parametroObrigatorioInformarIndicadorNaVenda || bloquearGeracaoContaAPagarIndicador) && checkboxBloquearGeracaoContaAPagarIndicador} 
        {(props.exibirCampoProgramaDeRelacionamento) && campoProgramaDeRelacionamento}
        
      </div>
      {botaoAplicarComissao}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
